import "./scss/App.css";

import {  Sidebar, BottomNavigator } from "./components";

import { Grid } from "@mui/material";
import Routes from "./routes/Index";
import { ThemeProvider } from "styled-components";
import { darktheme } from "./styles/theme";

function App() {
  // ---- Hidding all console logs ----
  console.log = console.warn = console.error = () => {};

  return (
    <>
      <ThemeProvider theme={darktheme}>
        
        <Grid container>
          
          <Grid item lg={2} md={2} sm={4} id="sidebar-wrapper">
            <Sidebar />
          </Grid>

          <Grid item lg={10} md={10} sm={12} xs={12} id="page-content-wrapper">
            <Routes />
            <div className="bottom-bar">
            {/* <BottomBar /> */}
            <BottomNavigator />
          </div>
          </Grid>
        
        </Grid>
      </ThemeProvider>
    </>
  );
}

export default App;
